import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink/ExternalLink';
import { WizardStep } from '@/components/Wizard';
import { CONTACT_US_URL } from '@/constants';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';
import { selectResources } from '@/reducers/common/selectors';

import styles from './ClaimBookingStep.module.scss';

type ClaimBookingErrorProp = {
  tabId: string;
  onCancel: () => void;
};

const NoContactDetail: React.FC<ClaimBookingErrorProp> = ({ tabId, onCancel }) => {
  const appUiData = useAppUiData();
  const resources = useSelector(selectResources);

  return (
    <WizardStep tabId={tabId}>
      <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.noContactDetailsTitle]}</h2>
      <p className={styles.subtitle}>{appUiData[appUiIds.claimBooking.noContactDetailsBody]}</p>
      <Button variant="secondary" className={styles.buttonOk}>
        <ExternalLink href={resources[CONTACT_US_URL] as string} name={appUiData[appUiIds.claimBooking.contactUS]} />
      </Button>
      <Button onClick={onCancel} className={styles.cancelLink}>
        {appUiData[appUiIds.commonLabels.cancel]}
      </Button>
    </WizardStep>
  );
};

export default NoContactDetail;
